import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import {  getLLMScheduledPrompt, scheduledPromptsByAgentId, scheduledPromptsByProjectId } from "../graphql/queries";
import { GetLLMScheduledPromptQuery, ListLLMScheduledPromptsQuery, LLMScheduledPromptStatus, ScheduledPromptsByAgentIdQuery, ScheduledPromptsByProjectIdQuery } from "../API";

export async function fetchScheduledPromptsForAgent(
  agentId: string
): Promise<GraphQLResult<ScheduledPromptsByAgentIdQuery>> {

  console.log("fetchScheduledPromptsForAgent", agentId);
  
  return API.graphql(
    graphqlOperation( scheduledPromptsByAgentId, {
      agentId: agentId,
    })
  ) as Promise<GraphQLResult<ScheduledPromptsByAgentIdQuery>>;
}

export async function fetchLLMScheduledPrompt(
  id: string
): Promise<GraphQLResult<GetLLMScheduledPromptQuery>> {

  return API.graphql(
    graphqlOperation(getLLMScheduledPrompt, {
      id: id,
    })
  ) as Promise<GraphQLResult<GetLLMScheduledPromptQuery>>;
}

export async function fetchScheduledPromptsForProject(
  projectId: string,
  status?: LLMScheduledPromptStatus
): Promise<GraphQLResult<ScheduledPromptsByProjectIdQuery>> {

  const variables: any = {
    projectId: projectId,
  };

  if (status) {
    variables.sortDirection = "ASC";
    variables.status = {
      eq: status
    };
  }

  return API.graphql(
    graphqlOperation( scheduledPromptsByProjectId, variables)
  ) as Promise<GraphQLResult<ScheduledPromptsByProjectIdQuery>>;
}